import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { alreadyLoggedCheckGuard } from './guards/authentication.guard';
import { EntraAuthenticatorComponent } from './login/entra-authenticator/entra-authenticator.component';
import { LogoutComponent } from './logout/logout.component';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [alreadyLoggedCheckGuard],
    component: WelcomePageComponent,
  },
  {
    path: 'login',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'entra-authenticator',
    component: EntraAuthenticatorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AuthRouting {}
